import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

declare interface RouteInfo {
  title: string;
  text: string;
  url1: string;
  url2: string;
  url3: string;
  url4: string;
  url5: string;
  pdf1: string;
  pdf2: string;
  pdf3: string;
  pdf4: string;
  pdf5: string;
}

export const FinancialContent: RouteInfo[] = [
  {
    title: 'IRS 990 Forms',
    text: "The IRS Form 990 is an annual reporting return that certain federally tax-exempt organizations must file with the IRS. It provides information on CHCC's mission, programs, and finances. It is an information return and not an income tax return. The California Hispanic Chambers of Commerce is a tax-exempt non-profit organization recognized under the IRS Tax Code 501(c)(6), an association of persons with common business interests to promote their common interests and improve business conditions.",
    pdf1: '2021 CA Hispanic Chambers of Commerce Form 990',
    url1: '../../../assets/files/Financial/2021 CHCC 990.pdf',
    pdf2: '2020 CA Hispanic Chambers of Commerce Form 990',
    url2: '../../../assets/files/Financial/2020 CHCC 990.pdf',
    pdf3: '2019 CA Hispanic Chambers of Commerce Form 990',
    url3: '../../../assets/files/Financial/8038876-Form990-2019.pdf',
    pdf4: '2018 CA Hispanic Chambers of Commerce Form 990',
    url4: 'https://pdf.guidestar.org/PDF_Images/2018/680/046/2018-680046058-17183348-9O.pdf?_gl=1%2a11qm6vf%2a_ga%2aODI3OTU2MTgwLjE2NjQ4OTgzMDU.%2a_ga_5W8PXYYGBX%2aMTY2NDg5ODMwNC4xLjEuMTY2NDg5ODM5NC4zMy4wLjA.&_ga=2.252145419.322476741.1664898306-827956180.1664898305',
    pdf5: '2017 CA Hispanic Chambers of Commerce Form 990',
    url5: 'https://pdf.guidestar.org/PDF_Images/2017/680/046/2017-680046058-0f2033b0-9O.pdf?_gl=1%2a4y7ffa%2a_ga%2aODI3OTU2MTgwLjE2NjQ4OTgzMDU.%2a_ga_5W8PXYYGBX%2aMTY2NDg5ODMwNC4xLjEuMTY2NDg5ODM4Ni40MS4wLjA.&_ga=2.252145419.322476741.1664898306-827956180.1664898305',
  },
];

@Component({
    selector: 'app-financial',
    templateUrl: './financial.component.html',
    styleUrls: ['./financial.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FinancialComponent implements OnInit {
  mainTitle = 'Financials';
  lists: any = [];

  constructor() {}

  ngOnInit(): void {
    this.lists = FinancialContent.filter((list) => list);
  }
}
